import script from "./InfoStoryPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoStoryPage.vue?vue&type=script&setup=true&lang=ts"

import "./InfoStoryPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__